const formatSettings = (settings = {}, defaultSettings) => {
  const {
    card = {},
    bubbleButton = {},
    header = {},
    messageNotification = {},
    rollout = {},
    bot = {},
    mediaQueryThresholds = {},
    userMessage = {},
    menu = {},
    wordSuggestions = {},
    screenReaderLabels = {},
    textToSpeech = {},
  } = settings;

  return {
    card: {
      title: card.title || settings.title || defaultSettings.card.title,
      subTitle: card.subTitle || settings.subTitle || defaultSettings.card.subTitle,
      imageUrl: card.imageUrl || settings.iconImageUrl,
      buttonText: card.buttonText || settings.buttonText || defaultSettings.card.buttonText,
      buttonTextColor: card.buttonTextColor || settings.buttonTextColor,
    },
    bubbleButton: {
      imageUrl: bubbleButton.imageUrl,
      backgroundColor: bubbleButton.backgroundColor || settings.iconBackgroundColor,
      text: bubbleButton.text ?? (settings.miniIconTitle || defaultSettings.bubbleButton.text),
      bottomMargin: {
        mobile: bubbleButton.bottomMargin?.mobile,
        desktop: bubbleButton.bottomMargin?.desktop,
      },
      sideMargin: {
        mobile: bubbleButton.sideMargin?.mobile,
        desktop: bubbleButton.sideMargin?.desktop,
      },
    },
    rollout: {
      text:
        rollout.text ||
        messageNotification.text ||
        defaultSettings.rollout.text ||
        defaultSettings.messageNotification.text,
      showOnMobile: rollout.showOnMobile || false,
    },
    header: {
      logoUrl: header.logoUrl,
      buttonColor: header.buttonColor,
      logoText: header.logoText,
    },
    bot: {
      avatarUrl: bot.avatarUrl || header.avatarUrl,
    },
    userMessage: {
      color: userMessage.color,
      backgroundColor: userMessage.backgroundColor,
    },
    menu: {
      color: menu.color,
      backgroundColor: menu.backgroundColor,
      itemBackgroundColor: menu.itemBackgroundColor,
    },
    wordSuggestions: {
      color: wordSuggestions.color,
      backgroundColor: wordSuggestions.backgroundColor,
    },
    screenReaderLabels: {
      regionTitle: screenReaderLabels.regionTitle || defaultSettings.screenReaderLabels.regionTitle,
      loading: screenReaderLabels.loading || defaultSettings.screenReaderLabels.loading,
      dismiss: screenReaderLabels.dismiss || defaultSettings.screenReaderLabels.dismiss,
    },
    zIndex: settings.zIndex,
    align: settings.align,
    mediaQueryThresholds: {
      mobile: mediaQueryThresholds.mobile,
    },
    onOpen: settings.onOpen,
    textToSpeech: {
      enabled: textToSpeech.enabled,
      avatar: textToSpeech.avatar && {
        silent: { src: textToSpeech.avatar?.silent?.src },
        speaking: { src: textToSpeech.avatar?.speaking?.src },
      },
      control: {
        label: textToSpeech.control?.label || defaultSettings.textToSpeech.control.label,
      },
    },
  };
};

export default formatSettings;
